/**
 * <submit-loading [auto-captcha]> ... <template>loading markup</template></submit-loading>
 * Place inside the region that holds a form. When a form in the parent region is
 * submitted, its submit control shows the template's "processing" label with a
 * spinner and is marked busy. Works for <button> and <input type="submit">.
 * With `auto-captcha`, the form submits by itself once the security check is ticked.
 */
class SubmitLoading extends HTMLElement {
  connectedCallback() {
    this.region = this.parentElement;
    if (!this.region) return;
    this.onSubmit = (event) => this.showLoading(event.target, event.submitter);
    this.region.addEventListener('submit', this.onSubmit);
    if (this.hasAttribute('auto-captcha')) {
      this.poll = window.setInterval(() => this.checkCaptcha(), 400);
    }
  }

  disconnectedCallback() {
    if (this.region && this.onSubmit) this.region.removeEventListener('submit', this.onSubmit);
    if (this.poll) window.clearInterval(this.poll);
  }

  checkCaptcha() {
    const response = this.region.querySelector('[name="h-captcha-response"], [name="g-recaptcha-response"]');
    if (!response || !response.value) return;
    window.clearInterval(this.poll);
    this.poll = null;
    const form = response.form || response.closest('form');
    if (!form || form.dataset.loading) return;
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      this.showLoading(form, null);
      form.submit();
    }
  }

  showLoading(form, submitter) {
    if (!(form instanceof HTMLFormElement) || form.dataset.loading) return;
    form.dataset.loading = 'true';
    const button = submitter || form.querySelector('[type="submit"]');
    const template = this.querySelector('template');
    if (!template) return;
    const label = this.getAttribute('label') || '';
    requestAnimationFrame(() => {
      if (button) {
        button.setAttribute('aria-busy', 'true');
        button.classList.add('pointer-events-none', 'opacity-90');
      }
      if (button && button.tagName === 'BUTTON') {
        button.replaceChildren(template.content.cloneNode(true));
      } else {
        if (button) button.value = label;
        const status = document.createElement('div');
        status.className = 'mt-4 flex justify-center';
        status.append(template.content.cloneNode(true));
        (button || form).insertAdjacentElement(button ? 'afterend' : 'beforeend', status);
      }
    });
  }
}

if (!customElements.get('submit-loading')) customElements.define('submit-loading', SubmitLoading);
